import { render, staticRenderFns } from "./wordList.vue?vue&type=template&id=4b0898e2&"
import script from "./wordList.vue?vue&type=script&lang=js&"
export * from "./wordList.vue?vue&type=script&lang=js&"
import style0 from "./wordList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports